// extracted by mini-css-extract-plugin
export var MailchimpSubscribe = "G_bK";
export var aniBgLoading = "G_f";
export var aniSpin = "G_d";
export var input = "G_bL";
export var message = "G_bP";
export var submit = "G_bM";
export var submitBtn = "G_bN";
export var wrap = "G_bm";